import { useNavigate } from "react-router-dom";
import { ShoppingCart, ClipboardList, Boxes, Settings, ChevronRight, Truck } from "lucide-react";

const modules = [
  {
    id: "pedidos",
    title: "Pedidos",
    subtitle: "Para repartidores",
    description: "Registra cantidades y exporta ticket de pedido",
    icon: ShoppingCart,
    path: "/pedidos",
    accent: "emerald",
    testId: "nav-pedidos-button",
  },
  {
    id: "traslados",
    title: "Traslados",
    subtitle: "Para repartidores",
    description: "Registra traslados entre sedes y exporta documento",
    icon: Truck,
    path: "/traslados",
    accent: "sky",
    testId: "nav-traslados-button",
  },
  {
    id: "inventario",
    title: "Inventario",
    subtitle: "Para jefes de cocina / bodega",
    description: "Control de stock y exportar a Excel",
    icon: ClipboardList,
    path: "/inventario",
    accent: "amber",
    testId: "nav-inventario-button",
  },
  {
    id: "inventario-general",
    title: "Inventario General",
    subtitle: "Para jefes de cocina / bodega",
    description: "Control general de stock y exportar a Excel",
    icon: Boxes,
    path: "/inventario-general",
    accent: "amber",
    testId: "nav-inventario-general-button",
  },
  {
    id: "admin",
    title: "Administración",
    subtitle: "Backoffice",
    description: "Gestionar productos, sedes y zonas",
    icon: Settings,
    path: "/admin",
    accent: "neutral",
    testId: "nav-admin-button",
  },
];

const accentStyles = {
  emerald: {
    icon: "text-emerald-400",
    bg: "bg-emerald-400/10",
    border: "border-emerald-400/20",
  },
  sky: {
    icon: "text-sky-400",
    bg: "bg-sky-400/10",
    border: "border-sky-400/20",
  },
  amber: {
    icon: "text-amber-400",
    bg: "bg-amber-400/10",
    border: "border-amber-400/20",
  },
  neutral: {
    icon: "text-neutral-400",
    bg: "bg-neutral-800",
    border: "border-neutral-700",
  },
};

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-neutral-950" style={{ fontFamily: "'Outfit', sans-serif" }}>
      {/* Header */}
      <div className="px-4 pt-14 pb-8 border-b border-neutral-900">
        <div className="max-w-md mx-auto">
            <h1 className="text-3xl font-bold tracking-tight text-neutral-50">
            Sistema de gestión
          </h1>
        </div>
      </div>

      {/* Module cards */}
      <div className="px-4 pt-6 pb-10 max-w-md mx-auto space-y-3">
        {modules.map((module) => {
          const Icon = module.icon;
          const accent = accentStyles[module.accent];
          return (
            <button
              key={module.id}
              data-testid={module.testId}
              onClick={() => navigate(module.path)}
              className="w-full flex items-center gap-4 p-5 bg-neutral-900 border border-neutral-800 rounded-md active:bg-neutral-800 transition-colors duration-150 text-left"
            >
              <div
                className={`p-3 rounded-md ${accent.bg} border ${accent.border} shrink-0`}
              >
                <Icon className={`w-6 h-6 ${accent.icon}`} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-neutral-50 font-semibold text-base">
                  {module.title}
                </div>
                <p className="text-neutral-500 text-xs mt-1">
                  {module.description}
                </p>
              </div>
              <ChevronRight className="w-5 h-5 text-neutral-600 shrink-0" />
            </button>
          );
        })}
      </div>

      {/* Footer */}
      <div className="px-4 pb-8 max-w-md mx-auto">
        <p className="text-neutral-700 text-xs text-center">
          Creado por Angel Bohorquez
        </p>
      </div>
    </div>
  );
};

export default HomePage;